import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import type { CustomLandingPageBoatDetail } from 'src/common/types/api/v4/boats/search';
import {
  landingPageContent, topDestinationSlugs, topListings,
} from 'src/bachelorette/landingPageContent';
import LandingPageTopListings from 'src/common/components/LandingPageTopListings';
import LandingPageBoatTypes from 'src/common/components/LandingPageBoatTypes';
import HowItWorks from 'src/common/components/HowItWorks';
import LandingPageReviews from 'src/common/components/LandingPageReviews';
import LandingPageJournal from 'src/common/components/LandingPageJournal';
import LandingPageTopDestinations from 'src/common/components/LandingPageTopDestinations';
import LandingPageListingsByLocation from 'src/common/components/LandingPageListingsByLocation';
import Hero from '../Hero';
import FAQs from '../FAQs';

type BachelorettePageRootProps = {
  austinListings: CustomLandingPageBoatDetail[];
  mexicoListings: CustomLandingPageBoatDetail[];
  miamiListings: CustomLandingPageBoatDetail[];
};

const BachelorettePageRoot: FC<BachelorettePageRootProps> = ({
  austinListings,
  mexicoListings,
  miamiListings,
}) => {
  const [t] = useTranslation('bachelorette-page');
  const listingsByLocation = [
    {
      ctaSlug: 'Miami--FL--United-States',
      ctaText: 'cta--Miami--FL--United-States',
      listings: miamiListings,
      title: 'title--Miami--FL--United-States',
    },
    {
      ctaSlug: 'Austin--TX--United-States',
      ctaText: 'cta--Austin--TX--United-States',
      listings: austinListings,
      title: 'title--Austin--TX--United-States',
    },
    {
      ctaSlug: 'Mexico',
      ctaText: 'cta--Mexico',
      listings: mexicoListings,
      title: 'title--Mexico',
    },
  ];
  return (
    <main>
      <Hero />
      <LandingPageTopListings
        subtitle={t('top-listings--subtitle')}
        title={t('top-listings--title')}
        topListings={topListings}
        translationFunction={t}
      />
      <LandingPageReviews
        clampLines={false}
        headingSize="display-5"
        title={t('reviews--title')}
        reviews={landingPageContent.reviews?.top_reviews}
        translationFunction={t}
      />
      <LandingPageListingsByLocation
        listingLocations={listingsByLocation}
        translationFunction={t}
      />
      <LandingPageTopDestinations
        layoutBackgroundColor="ivory"
        slugs={topDestinationSlugs}
        title={t('top-destinations--title')}
        translationFunction={t}
      />
      <LandingPageBoatTypes
        ctaText={t('button--browse-boats')}
        listingTypes={landingPageContent.listing_types}
        title={t('boat-types--title')}
      />
      <LandingPageJournal
        cardCta={t('journal--card-cta')}
        headingSize="display-5"
        journals={landingPageContent.journal_pages?.items}
        title={t('journal--title')}
        translationFunction={t}
      />
      <HowItWorks headingColor="midnight01" headingSize="display-5" />
      <FAQs />
    </main>
  );
};

export default BachelorettePageRoot;
